import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import { createClusterApi } from './index';
import type { ClusterApi } from './client';

/** The mirror of AccountApiProvider, mounted only inside the cluster tree. */
const ClusterApiContext = createContext<ClusterApi | null>(null);

export function ClusterApiProvider({
  children,
  client,
}: {
  children: ReactNode;
  client?: ClusterApi;
}) {
  const value = useMemo(() => client ?? createClusterApi(), [client]);
  return <ClusterApiContext value={value}>{children}</ClusterApiContext>;
}

export function useClusterApi(): ClusterApi {
  const value = useContext(ClusterApiContext);
  if (value === null) {
    throw new Error('useClusterApi() used outside <ClusterApiProvider>');
  }
  return value;
}
